import { getOrMakeUnitDefinitionFromMdsSiMarkup } from '@metservicedev/cf-units';
import { Col } from 'antd';
import chunk from 'lodash/chunk';
import React, { useMemo } from 'react';

import { IWidgetBlockComponent } from '../types/IWidgetBlock';
import latexElement from '../../utils/latexElement';
import roundNumberSF from '../../utils/roundNumberSF';
import {
    LabelContainer,
    SingleCurrentValueContainer,
    SingleCurrentValueEntry,
    StyledRow,
    TimeContainer,
    TimeContainerAbsolute,
    ValueContainer,
    ValueSpan,
} from './SingleCurrentValue.style';
import { SingleCurrentValueModel } from './types';

const SingleCurrentValue: React.FC<IWidgetBlockComponent<SingleCurrentValueModel>> = ({ widgetModel }) => {
    if (!widgetModel) {
        return null;
    }

    const { items } = widgetModel;
    const chunkedItems = useMemo(() => chunk(items, 3), [items]);
    const fontSize = widgetModel.fontSize || 100;
    const align = widgetModel.align || 'center';

    return (
        <SingleCurrentValueContainer className='singleCurrentValueRender' align={align}>
            {chunkedItems.map((items, i) => (
                <StyledRow gutter={16} align='middle' key={i}>
                    {items.map(({ id, label, value, sf, unit, time }) => {
                        const displayValue = value && typeof value === 'number' ? roundNumberSF({ num: value, sf }) : 'no data';
                        const latexUnit = (unit && getOrMakeUnitDefinitionFromMdsSiMarkup(unit).niceLatex) || '';
                        const unitLabel = latexElement(latexUnit);
                        const valueTime = time?.format('MMM D LT');
                        const valueTimeRelative = time?.fromNow();

                        return (
                            <Col key={id} span={24 / items.length}>
                                <SingleCurrentValueEntry fontSize={fontSize}>
                                    <LabelContainer>{label || ''}</LabelContainer>
                                    <ValueContainer>
                                        <ValueSpan>
                                            {`${displayValue} `}
                                            {unitLabel}
                                        </ValueSpan>
                                    </ValueContainer>
                                    <TimeContainer>{valueTimeRelative}</TimeContainer>
                                    <TimeContainerAbsolute>{valueTime}</TimeContainerAbsolute>
                                </SingleCurrentValueEntry>
                            </Col>
                        );
                    })}
                </StyledRow>
            ))}
        </SingleCurrentValueContainer>
    );
};

export default SingleCurrentValue;
